export default "__VITE_ASSET__C4t1esHQ__"